import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';

/* actions */
import * as Actions from '../../redux/actions';


class DoPaymentRequest extends baseRequest{

    constructor(onPurchase) {
        super();
        this.payload    = {};
        this.dispatch   = null;
        this.response   = null;
        this.name       = 'DoPaymentRequest';
        this.Config     = new AppConfig();
        this.onPurchase = onPurchase;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload  = payload;
        this.call(this.Config.api.requests.doPayment, payload);
    }

    onSuccess() {
        this.updateState();
    }

    updateState() {
        this.onPurchase(this.response.data);
        this.dispatch(Actions.setOrderDone(this.response.data));
    }

    onFailure(response) {
        AnalyticsManager.logProductBuyWithClickFailed(this.payload?.benefitId);
        super.onFailure(response);
    }
}

export default DoPaymentRequest;
